// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { UrlUtils } from '@shared/utils/UrlUtils';
export var NewsPriority;
(function (NewsPriority) {
    NewsPriority[NewsPriority["High"] = 1] = "High";
    NewsPriority[NewsPriority["Middle"] = 5] = "Middle";
    NewsPriority[NewsPriority["Low"] = 10] = "Low";
})(NewsPriority || (NewsPriority = {}));
export class News {
    constructor(newsGroup) {
        this.received = new Date();
        this.source = '';
        this.subject = '';
        this.contentIsLink = false;
        this.category = '';
        this.symbol = '';
        this.priority = null;
        this.routeID = null;
        this.newsID = null;
        this.text = '';
        this.allLines = '';
        this.line0 = '';
        this.line2 = '';
        this.content = '';
        if (!isNullOrUndefined(newsGroup)) {
            this.UpdateByMsg(newsGroup);
        }
    }
    UpdateByMsg(newsGroup) {
        this.received = newsGroup.getDate();
        this.source = newsGroup.getSource();
        this.subject = newsGroup.getTheme();
        const content = newsGroup.getContent();
        if (typeof content === 'string') {
            this.contentIsLink = false;
            this.content = content;
        }
        else {
            this.contentIsLink = content.isUrl;
            this.content = content.url;
        }
        this.category = newsGroup.getCategory();
        this.symbol = newsGroup.getSymbol();
        this.priority = newsGroup.getPriority();
        this.routeID = newsGroup.getRouteID();
        this.newsID = newsGroup.getNewsID();
        this.text = newsGroup.getText();
        this.allLines = newsGroup.getAllLines();
        this.line0 = newsGroup.getContentByLineNumber(0);
        this.line2 = newsGroup.getContentByLineNumber(2);
    }
    GetID() {
        return this.newsID;
    }
    GetRouteID() {
        return this.routeID;
    }
    GetDate() {
        return this.received;
    }
    OnNewsDoubleClicked() {
        if (UrlUtils.isUrl(this.line2)) {
            UrlUtils.openFixedURL(this.line2);
            return;
        } // Если в NEWS_MESSAGE(52) в поле TEXT[115] с LINE_NUMBER[118]=2 - пришла линка, то по дабл клику на новость открываем новость в новой вкладке браузера.
        const url = News.getLinkFromText(this.text); // Дополнительно делаем проверку: если в теге выше не пришла ссылка, то проверяем наличие ссылки в теге TEXT[115], тег может содержать только ссылку, либо ссылка может быть с текстом.
        if (!isNullOrUndefined(url) && UrlUtils.isUrl(url)) {
            UrlUtils.openFixedURL(url);
            return;
        }
        const newWin = window.open(''); // Если в NEWS_MESSAGE(52) в поле TEXT[115] с LINE_NUMBER[118]=2 - не пришла линка, то по дабл клику на новость открываем в новой вкладке. Во вкладке браузера отображаем контент из тега TEXT[115] с LINE_NUMBER[118]=0.
        if (isNullOrUndefined(newWin)) {
            return;
        }
        const doc = newWin.document;
        doc.open();
        const content = this.contentIsLink ? this.line0 : this.content;
        if (!isNullOrUndefined(content)) {
            doc.body.innerHTML = content;
        } // Всратое гавно https://tp.traderevolution.com/entity/101031
        doc.close();
    }
    static getLinkFromText(text) {
        const urls = UrlUtils.ParseTextForURL(text, true);
        for (const url of urls) {
            let value = url.value;
            if (!url.isText) {
                value = value.replace('"', '');
            }
            if (UrlUtils.isUrl(value)) {
                return value;
            }
        }
        return null;
    }
}
